<template>
  <v-container
    fluid
  >
    <base-material-card
      inline
      icon="mdi-magnify"
      title="Search results"
    >
      <empty-space></empty-space>
      <template v-if="hasSearchText">
        <template v-if="showLoader">
          <loader></loader>
          <h2>Searching ...</h2>
        </template>
        <template v-if="!showLoader">
          <h2>{{ title }}</h2>
          <small>Search results are limited to 50 entries.</small>
          <data-local-table
            ref="table"
            :fields="fields"
            :items="results"
          >

            <template
              slot="active_candidate"
              slot-scope="slotData"
            >
              {{ slotData.rowData.active_candidate|formatBool|noDataAvailable }}
            </template>

            <template
              slot="actions"
              slot-scope="slotData"
            >
              <v-btn
                x-small
                color="primary"
                @click="showPage(slotData.rowData)"
              >Details</v-btn>
            </template>

          </data-local-table>
        </template>
      </template>
      <template v-if="!hasSearchText">
        <p><b>No search text specified.</b></p>
      </template>
    </base-material-card>
  </v-container>
</template>

<script>
  import EmptySpace from '../../components/EmptySpace'
  import Loader from '../../components/Loader'
  import SitesService from '@/services/sites'
  import DataLocalTable from '@/components/DataLocalTable'

  export default {
    name: 'Index',
    components: { DataLocalTable, Loader, EmptySpace },
    data: () => ({
      searchText: undefined,
      showLoader: true,
      results: undefined,
      fields: [
        {
          name: 'site_id',
          title: 'Site id',
        },
        {
          name: 'site_name',
          title: 'Site name',
        },
        {
          name: '__slot:active_candidate',
          title: 'Active candidate',
        },
        {
          name: 'type',
          title: 'Type',
        },
        {
          name: '__slot:actions',
          title: 'Actions',
        },
      ],
    }),
    watch: {
      $route (to, from) {
        this.executeSearch()
      },
    },
    computed: {
      title () {
        return 'Showing search results for "' + this.searchText + '"'
      },
      hasSearchText () {
        return this.searchText && this.searchText.length > 0
      },
    },
    mounted () {
      this.executeSearch()
    },
    methods: {
      executeSearch () {
        this.showLoader = true
        this.searchText = this.$route.query.q
        const ss = new SitesService()
        ss.search(this.searchText).then((response) => {
          this.results = response.data.data
        }).finally(() => {
          this.showLoader = false
        })
      },
      showPage (entry) {
        this.$router.push({ path: `/sites/${entry.id}/view` })
      },
    },
  }
</script>

<style scoped>

</style>
